import styled from "styled-components";

export const StyledHistoryExperienceModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 330px;
  box-sizing: border-box;

  & .input-row {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;

    & .mb {
      margin-bottom: 20px;
    }

    & div {
      max-width: 265px;
    }
  }

  & .toggle-container {
    display: flex;
    flex-direction: row;
    gap: 10px;
    padding-top: 16px;
  }
`;
